// core version + certain modules modules:
import SwiperCore, {Navigation, Pagination, Autoplay, EffectFade, Controller} from 'swiper/core';

// configure Swiper to use modules
SwiperCore.use([Navigation, Pagination, Autoplay, EffectFade, Controller]);

let swiperOnPage = false;
const Swipers = {}
if (document.querySelectorAll('.partner-slider').length > 0) {
    swiperOnPage = true;
    Swipers.partnerSlider = new SwiperCore('.partner-slider ', {
        autoplay: true,
        spaceBetween: 0,
        loop: true,
        slidesPerView: 2,
        breakpoints: {
            676: {
                slidesPerView: 4,
            },
            992: {
                slidesPerView: 6,
            }
        }
    });
}

if (document.querySelectorAll('.image-carousel').length > 0) {
    swiperOnPage = true;
    Swipers.imageCarousel = new SwiperCore('.image-carousel ', {
        autoplay: true,
        spaceBetween: 10,
        loop: true,
        loopAdditionalSlides: 1,

        breakpoints: {
            676: {
                spaceBetween: 24,
            }
        }
    });
}

